import BeatSaverBrowser from "./BeatSaverBrowser";
export default BeatSaverBrowser;
